
import { Component, Watch } from 'vue-property-decorator';

import Booking from '@/views/Booking.vue';

import { BookingsApi } from '@/api/BookingsApi';

import { HotelsApi } from '@/api/HotelsApi';

import slugify from 'slugify';

import { mapState } from 'vuex';

import { MetaInfo } from 'vue-meta';

import { sortBy, first, mapValues, find } from 'lodash';

import { defaultColors } from '@/config/functions';

import { striposMixin } from '@/mixins/striposMixin.js';

import { colorTooltipsMixin } from '@/mixins/colorTooltipsMixin.js';

import { findColor, parseFloatCustom } from '@/config/functions';

@Component({
   computed: {
      ...mapState({
         activities_colors: (s: any) => s.activities.colors,
         dataReady: (s: any) => s.ready,
      }),
   },
   filters: {
      reduce_sum: (items: any[], index: string | number) =>
         items.length ? items.map(a => (a[index] != '' ? parseFloatCustom(a[index]) : 0)).reduce((a, b) => a + b) : 0,
   },
   metaInfo(): MetaInfo {
      return {
         title: '',
         titleTemplate: 'Order list',
      };
   },
   mixins: [striposMixin, colorTooltipsMixin],
})
export default class Calendar extends Booking {
   form: any;

   stripos!: any;

   addColorTooltips!: any;

   activities_colors!: any[];

   fields: any[] = [
      {
         key: 'o_overal_status',
         label: 'status',
         thAttr: {
            style: 'width: 43px;',
         },
      },
      {
         key: 'o_group_color',
         label: 'group color',
         thAttr: {
            style: 'width: 43px;',
         },
      },
      {
         key: 'o_check_in_date',
         sortable: true,
         label: 'check-in',
         thAttr: {
            style: 'width: 228px;',
         },
      },
      {
         key: 'o_lead_guest',
         sortable: true,
         label: 'lead guest',
         thAttr: {
            style: 'width: 232px;',
         },
      },
      {
         key: 'o_pax',
         sortable: true,
         label: 'pax',
         thAttr: {
            style: 'width: 40px;',
         },
      },
      {
         key: 'o_agent',
         sortable: true,
         label: 'agent',
      },
      {
         key: 'o_our_reference',
         sortable: true,
         label: 'our ref',
      },
      {
         key: 'o_activity_gp',
         sortable: true,
         label: 'activ. gp €',
      },
      {
         key: 'o_accommodation_gp',
         sortable: true,
         label: 'acc gp €',
      },
      {
         key: 'o_total_gp',
         sortable: true,
         label: 'total gp €',
      },
      {
         key: 'o_stay_in',
         sortable: true,
         label: 'stay in',
         thAttr: {
            style: 'width: 334px;',
         },
      },
      {
         key: 'o_self_arranged_accommodation',
         sortable: true,
         label: 'accom. type',
         thAttr: {
            style: 'width: 155px;',
         },
      },
      {
         key: 'o_result_of_compare_price_and_invoices',
         sortable: true,
         label: 'invoicing',
         thAttr: {
            style: 'width: 120px;',
         },
      },
   ];

   rooms: any[] = [];

   accommodations: any[] = [];

   filtered: any[] = [];

   totalOPax: number = 0;

   totalActivityGp: number = 0;

   totalAccommodationGp: number = 0;

   totalTotalGp: number = 0;

   totalLeadGuest: number = 0;

   dataReady!: boolean;

   filter: any = {
      o_group_color: '#FEFEFE',
      o_overal_status: '#ffffff',
   };

   dateRange: Date[] = [];

   created(): void {
      const $start = this.$moment(this.$localStorage.getItem('order-list.startDate'));
      const $end = this.$moment(this.$localStorage.getItem('order-list.endDate'));

      this.dateRange = [
         $start.isValid() ? $start.toDate() : this.$moment().toDate(),
         $end.isValid()
            ? $end.toDate()
            : this.$moment()
                 .add(30, 'd')
                 .toDate(),
      ];

      this.filter = {
         ...this.filter,
         ...mapValues(this.$route.query, (val: string) => {
            const value = val.split(';');
            return value.length == 1 ? first(value) : value;
         }),
      };
   }

   beforeDestroy(): void {
      this.$store.commit('showLoading');
   }

   @Watch('$route', { immediate: false, deep: true })
   onRoute(n: any, o: any) {
      if (n.name !== o.name) {
         this.findOrders();
      }
   }

   @Watch('dateRange', { immediate: false, deep: true })
   onChangeDateRange(n: string[]) {
      if (n.length) {
         this.$localStorage.setItem('order-list.startDate', n[0]);
         this.$localStorage.setItem('order-list.endDate', n[1]);
      }
      this.findOrders();
   }

   onRowSelected(n: any) {
      this.$router.push({ name: 'edit.order', params: { id: n.id } });
   }

   getRooms() {
      HotelsApi.rooms().then(rooms => {
         this.rooms = rooms;
         this.findOrders();
      });
   }

   tbodyTrClass(row: any) {
      return [this.formatterDate(row.o_check_in_date) == this.$moment().format('YYYY-MM-DD') ? 'today' : ''];
   }

   filterData() {
      const filter = {
         o_lead_guest: '',
         o_pax: '',
         o_our_reference: '',
         o_group_color: '#FEFEFE',
         o_overal_status: '#ffffff',
         o_activity_gp: '',
         o_total_gp: '',
         o_result_of_compare_price_and_invoices: '',
         o_accommodation_gp: '',
         o_self_arranged_accommodation: '',
         o_agent: '',
         o_stay_in: '',
         ...this.filter,
      };

      this.filtered = this.accommodations
         .map(a => ({
            ...a,
            f_lead_guest: a.o_lead_guest != null ? slugify(a.o_lead_guest).toUpperCase() : '',
            f_pax: parseInt(a.o_pax),
            f_our_reference: parseFloat(a.o_our_reference),
            f_activity_gp: parseFloat(a.o_activity_gp),
            f_total_gp: parseFloat(a.o_total_gp),
            o_result_of_compare_price_and_invoices: !['!!!', 'OK'].includes(a.o_result_of_compare_price_and_invoices)
               ? 0
               : a.o_result_of_compare_price_and_invoices,
         }))
         .filter(a => {
            const filtered: any = {
               o_lead_guest: this.stripos(a.f_lead_guest, filter.o_lead_guest),
               o_result_of_compare_price_and_invoices:
                  filter.o_result_of_compare_price_and_invoices == '' ||
                  (filter.o_result_of_compare_price_and_invoices == 0 && !['!!!', 'OK'].includes(a.o_result_of_compare_price_and_invoices)) ||
                  a.o_result_of_compare_price_and_invoices == filter.o_result_of_compare_price_and_invoices,
            };

            for (const f of Object.keys(filter)) {
               if (!a[f] || Object.keys(filtered).includes(f)) continue;

               if (f.indexOf('_status') >= 0 || f.indexOf('_color') >= 0) {
                  filtered[f] = !filter[f].length || findColor(filter[f], a[f], this.default_colors[f], this.activities_colors);
                  continue;
               }

               filtered[f] = filter[f] === '' || this.stripos(a[f], filter[f]);
            }

            return Object.keys(filtered).length == Object.values(filtered).filter(f => f).length;
         });

      this.totalOPax = (this.$options.filters as any).reduce_sum(this.filtered, 'o_pax');
      this.totalActivityGp = (this.$options.filters as any).reduce_sum(this.filtered, 'o_activity_gp').toFixed(2);
      this.totalAccommodationGp = (this.$options.filters as any).reduce_sum(this.filtered, 'o_accommodation_gp').toFixed(2);
      this.totalTotalGp = (this.$options.filters as any).reduce_sum(this.filtered, 'o_total_gp').toFixed(2);
      this.totalLeadGuest = this.filtered.length;
   }

   changeGroupColor(order: any, o_group_color: string) {
      order.o_group_color = o_group_color;

      BookingsApi.saveOrder(order.id, { 'change-group-color': '#' + o_group_color });
   }

   findOrders() {
      this.$store.commit('showLoading');

      if (!this.dataReady) {
         setTimeout(() => this.findOrders(), 1000);
         return;
      }

      let params = {
         dateFrom: this.$moment(this.dateRange[0]).format('YYYY-MM-DD'),
         dateTo: this.$moment(this.dateRange[1]).format('YYYY-MM-DD'),
         archive: this.$route.name == 'archive' ? 1 : 0,
      };

      this.$store.commit('setItems', { name: 'ready', value: false });

      Promise.all([this.$store.dispatch('activities/GET_DICTIONARIES'), BookingsApi.allOrdersList(params)])
         .then((data: any[]) => {
            const titleEl: any = document.querySelector('head title');
            if (this.$route.name !== 'archive') {
               titleEl.textContent = 'Order list';
            } else {
               titleEl.textContent = 'Archive';
            }
            this.accommodations = sortBy(data[1]['Order list'], 'o_check_in_date');
            this.filterData();
         })
         .finally(() => {
            this.addColorTooltips(['.orders-list'], this.activities_colors);
            this.$store.commit('setItems', { name: 'ready', value: true });
            this.$store.commit('hideLoading');
         });
   }

   @Watch('filter', { immediate: true, deep: true })
   changeFilter(filter: any) {
      const query = mapValues({ ...this.$route.query, ...filter }, value => {
         return Array.isArray(value) ? value.join(';') : value;
      });

      this.$router.push({ query }).catch(() => {});

      this.filterData();
   }
}
